import * as api from "../../utils/Api";
import { ProgressSpinner } from "primereact/progressspinner";
import { useRef, useState } from "react";
import ModalLoadSpinner from "../ui/modal/ModalLoadSpinner";
import { Toast } from "primereact/toast";
import { showMsg } from "../../utils/Constants";

const fileDownload = async (
  path: string,
  numDoc: string,
  setShowLoading: any,
  toastCenter: any,
) => {
  try {
    await api.FILE_DOWNLOAD.fileDownload(path).then((response) => {
      fileDownloadLocal(`/tmp/${numDoc}.zip`, setShowLoading, toastCenter);
    });
    /* const blob = await responseDownload.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = path.split("/").pop() || "downloaded_file";
    document.body.appendChild(a);
    a.click();
    a.remove();

    return <div>ok</div>;*/
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

const fileDownloadLocal = async (
  path: string,
  setShowLoading: any,
  toastCenter: any,
) => {
  const showMessage = (
    event: { target: { innerText: any } },
    ref: {
      current: {
        show: (arg0: {
          severity: any;
          summary: any;
          detail: any;
          life: number;
        }) => void;
      };
    },
    severity: string,
  ) => {
    const label = event.target.innerText;

    ref.current.show({
      severity: severity,
      summary: label,
      detail: label,
      life: 3000,
    });
  };

  try {
    const response = await api.FILES_DOWNLOAD_LOCAL.fileDownloadLocal(path);
    if (response !== null) {
      await api.FILE_TMP_DELETE_ZIP.fileZipDelete(path);
    } else {
      showMsg(toastCenter, "danger", "Error", "No hay archivos que descargar");
    }
    setShowLoading(false);
    return response;
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};

export default function DownloadFiles(props: any) {
  const [showLoading, setShowLoading] = useState(false);
  const toastCenter = useRef(null);

  return (
    <div>
      <Toast ref={toastCenter} />
      {showLoading ? <ModalLoadSpinner /> : null}
      <button
        className={props.className}
        onClick={() => {
          (setShowLoading(true),
            fileDownload(
              props.path,
              props.numDoc,
              setShowLoading,
              toastCenter,
            ));
        }}
      >
        <span style={{ fontSize: "0.6rem", fontWeight: "bold" }}>
          {props.pdf ? "PDF ↓" : "BAJAR ANEXOS ↓"}
        </span>
      </button>
    </div>
  );
}
